import PrivateConnectivityIcon from "@mui/icons-material/PrivateConnectivity";
import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import config from "../Config/config";
import Apuracao from "./Apuracao";
import Banner from "./Banner";
function Home({ keycloak }) {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [load, setLoad] = useState(false);
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [labelSolicitadoPor, setLabelSolicitadoPor] =
    useState("Solicitado Por");
  const [labelSolicitadoPorCpfCnpj, setLabelSolicitadoPorCpfCnpj] =
    useState("CPF");
 

  function handleClick() {
    const portal = config.portalUrl();
    window.location.href = `${portal}/artigo/42A971BF9291E234E06334CC17AC6C41/1`;
  }
  const handle = (e) => {};

  const verificarProcuracao = (procuracaoObj) => {
    const idProcurado = "42A971BF9291E234E06334CC17AC6C41";

    let existeServico = false;

    procuracaoObj.servicos.forEach((element) => {
      if (element.id === idProcurado) {
        existeServico = true;
      }
    });

    return existeServico;
  };

  useEffect(() => {
    // Adiciona o event listener para o evento "focus"
    window.addEventListener("visibilitychange", buscarRepresentacao);

    // Cleanup: remove o event listener quando o componente for desmontado
    return () => {
      window.removeEventListener("visibilitychange", buscarRepresentacao);
    };
  }, []);

  useEffect(() => {
    buscarRepresentacao();
  }, []);

  function buscarRepresentacao() {
    // Busca a representação com base no ID da query string

    setLoad(false);
    const baseUrl = config.apiUrl();
    if (id) {
      axios
        .get(`${baseUrl}/api/portal/v1/auth?id=${id}`, {
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        })
        .then((response) => {
          const userData = response.data;
          console.log(userData);
          if (userData.tipo == 1 || userData.tipo == 2) {
            setRazaoSocial(userData.nome);
            setCnpj(userData.cnpj);
            setLoad(true);
            setLabelSolicitadoPorCpfCnpj("CNPJ")
          } else {
            const { razaoSocial, cnpj } = response.data.representacoes[0];

            setRazaoSocial(razaoSocial);
            setCnpj(cnpj);

            const dados = response.data.representacoes[0];
            if (dados.procuracao != null) {
              setLabelSolicitadoPor("Solicitado Por Procurador");
              if (!verificarProcuracao(dados.procuracao)) {
                setLoad(false);
              } else {
                setLoad(true);
              }
            } else {
              setLoad(true);
            }
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar representação:", error);
        });
    }
  }

  return (
    <>
      <Banner
        titulo={"Sistema de Apuração do IBS"}
        handle={handle}
        descricao={""}
      />

      <Grid
        container
        spacing={4}
        sx={{
          marginTop: "40px",
        }}
      >
        <Grid size={{ xs: 1, md: 2 }}></Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          {keycloak?.authenticated && id && load ? (
            <Apuracao
              labelSolicitadoPor={labelSolicitadoPor}
              keycloak={keycloak}
              razaoSocial={razaoSocial}
              cnpj={cnpj} labelSolicitadoPorCpfCnpj={labelSolicitadoPorCpfCnpj}
            />
          ) : (
            <>
              <Card>
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      margin: "20px",
                      marginTop: "40px",
                      color: "#002B6F",
                      fontWeight: "bold",
                      fontSize: "30px",
                      textAlign: "center",
                    }}
                  >
                    Acesso Bloqueado
                  </Typography>
                  <PrivateConnectivityIcon sx={{ fontSize: "190px" }} />
                  <p>
                    Para obter acesso ao sistema de apuração, faça acesso pelo
                    PORTAL IBS
                  </p>
                  <p>
                    <Button onClick={handleClick} variant="contained">
                      Portal IBS
                    </Button>
                  </p>
                </CardContent>
              </Card>
            </>
          )}
        </Grid>

        <Grid size={{ xs: 1, md: 4 }}></Grid>
      </Grid>
    </>
  );
}

export default Home;
